type ViewLinkProps = {
  slug: string;
  id: string;
  available_stores: string[];
};
export const generateViewLink = (view: ViewLinkProps) => {
  const stores = new Set(view.available_stores);
  if (stores.intersection(new Set(["resources", "tasks"])).size === 2) {
    return `/p/${view.slug}/events/${view.id}`;
  }
  return `/p/${view.slug}/${view.available_stores[0]}/${view.id}`;
};
